"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = void 0;
var styles_1 = require("../../../../styles");
exports.createStyles = function (theme) { return ({
    button: {
        backgroundColor: 'transparent',
        border: '1px solid ' + theme.pallete.gray.c40,
        borderRadius: theme.radius.button,
        color: theme.pallete.text.main,
        textDecoration: 'none',
        ':not(:disabled):active': {
            boxShadow: 'inset 0 2px 8px 0 rgba(0, 0, 0, 0.1)',
        },
        ':focus': {
            outline: 'none',
            boxShadow: styles_1.focusBoxShadow(theme),
        },
        ':not(:disabled):hover': {
            backgroundColor: styles_1.hexToRGB(theme.pallete.gray.c50, 0.16),
        },
    },
    primary: {
        border: "1px solid " + theme.pallete.primary.main,
        color: theme.pallete.primary.main,
        ':not(:disabled):hover': {
            backgroundColor: styles_1.hexToRGB(theme.pallete.primary.main, 0.16),
        },
    },
    danger: {
        border: "1px solid " + theme.pallete.status.danger.main,
        color: theme.pallete.status.danger.main,
        ':not(:disabled):hover': {
            backgroundColor: styles_1.hexToRGB(theme.pallete.status.danger.main, 0.1),
        },
        ':focus': {
            boxShadow: styles_1.focusBoxShadow(theme, 'danger'),
        },
    },
}); };
//# sourceMappingURL=outline.js.map